module.exports = __webpack_public_path__ + "img/Wasteland_1.f70d5082.png";